import React, { useState, useEffect } from "react";

import useBookState from "./useBookState.ts";
import useAuthState from "../auth/useAuthState.js";
import { BookList } from "./BookList.tsx";
import Book from "./Book.ts";

function UnPaidBook(props: PropsValue) {
    const [list, setList] = useState(null);

    const { book_list, book_list_updated_at, getUpPaidList } = useBookState();
    const { token, getToken } = useAuthState();

    useEffect(() => {
        if (book_list_updated_at && book_list) {
            const list = book_list.map((item) => {
                return new Book(
                    item.id,
                    item.accommodation_id,
                    new Date(item.start_date),
                    item.name,
                    item.person_number,
                    item.price,
                    new Date(item.created_at),
                    item.payment_limit_date ? new Date(item.payment_limit_date) : null
                );
            });
            setList(list);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [book_list_updated_at]);

    useEffect(() => {
        if (token) {
            getUpPaidList(token);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {" "}
            {list ? (
                <div className="toggle-pannel-header">
                    <div className="toggle-title">未入金公式予約（24時間経過）</div>
                </div>
            ) : null}
            {list && token ? <BookList books={list} token={token} /> : null}
        </div>
    );
}

export default UnPaidBook;
